<template>
  <detail
    :data="data"
    :onManager="onManager"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    :nameRules="[{ required: true, message: this.$t('common.text00042') }]"
    :hiddenKeys="['tenant']"
    status-module="cloudaccount"
    :isEditDesc="false"
    :isEditName="false" />
</template>

<script>
import {
  getAccessUrlTableColumn,
  getBalanceTableColumn,
  getPublicScopeTableColumn,
  getResourceMatchProjectTableColumn,
} from '@Cloudenv/views/cloudaccount/utils/columns'
import { getBrandTableColumn, getEnabledTableColumn, getStatusTableColumn } from '@/utils/common/tableColumn'
import { findPlatform } from '@/utils/common/hypervisor'
import WindowsMixin from '@/mixins/windows'
import { hasMeterService } from '@/utils/auth'

export default {
  name: 'CloudaccountDetail',
  mixins: [WindowsMixin],
  props: {
    resId: {
      type: String,
      required: true,
    },
    accountData: Object,
    onManager: Function,
    columns: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      discount: 0,
      discountLoaded: false,
    }
  },
  computed: {
    baseInfo () {
      const isEdit = ['k8s', 'openshift'].includes(this.data.brand)
      return [
        getResourceMatchProjectTableColumn({ isEdit, editCallback: isEdit ? this.editCallback : null }),
        getPublicScopeTableColumn({ vm: this, resource: 'cloudaccounts' }),
        getBrandTableColumn(),
        {
          field: 'account',
          title: this.$t('cloudenv.text_94'),
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={ row } field='account' title={ row.account } />
                </div>,
              ]
            },
          },
        },
        {
          field: 'account_id',
          title: this.$t('cloudenv.text_94') + 'ID',
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={ row } field='account_id' title={ row.account_id } />
                </div>,
              ]
            },
          },
        },
        getEnabledTableColumn(),
        {
          field: 'read_only',
          title: this.$t('cloudenv.read_only'),
          formatter: ({ row }) => {
            return row.read_only ? this.$t('scope.text_251') : this.$t('scope.text_252')
          },
        },
        {
          field: 'last_sync',
          title: this.$t('cloudenv.text_103'),
          formatter: ({ row }) => {
            return this.$moment(row.last_sync).format()
          },
        },
      ]
    },
    extraInfo () {
      return [
        {
          title: this.$t('cloudenv.text_317'),
          items: [
            getAccessUrlTableColumn(),
            getStatusTableColumn({ statusModule: 'cloudaccountHealthStatus', title: this.$t('cloudenv.text_93'), field: 'health_status' }),
            {
              field: 'discount',
              title: this.$t('cloudaccount.table.title.discount'),
              slots: {
                default: () => {
                  if (!hasMeterService()) return '-'
                  if (!this.discountLoaded) {
                    return [<a-icon type='loading' style='font-size: 12px;' class='primary-color' />]
                  }
                  return [<span>{ (this.discount * 100).toFixed(2) }%</span>]
                },
              },
              hidden: () => findPlatform(this.data.brand?.toLowerCase()) !== 'public',
            },
            getBalanceTableColumn(),
          ],
        },
      ]
    },
    data () {
      return this.accountData
    },
  },
  created () {
    this.$cM = new this.$Manager('cloudaccounts')
    this.fetchDiscount()
  },
  methods: {
    editCallback () {
      this.createDialog('CloudaccountSetPojectmappingDialog', {
        data: [this.data],
        columns: this.columns,
        onManager: this.onManager,
        projectParams: { domain_id: this.data.domain_id },
        ignoreBlockedResources: true,
      })
    },
    async fetchDiscount () {
      if (!hasMeterService()) return
      if (this.resId === 'yunion') return
      try {
        const response = await this.$http({
          method: 'GET',
          url: `/v1/prices/discount/${this.resId}`,
        })
        this.discount = response.data.discount
      } finally {
        this.discountLoaded = true
      }
    },
  },
}
</script>
